import { HttpClient } from '@angular/common/http';
import { Component, ViewChild, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

/**
 * @title Table retrieving data through HTTP
 */
@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.scss']
})
export class DatatableComponent implements OnInit {
  @Input() tableData: any;
  @Input() name: any;
  @Input() cols: any;
  @Input() isAssistenza: any;
  @Input() paginatorSize: any;
  @Input() pageIndex: number;
  @Input() pageSize: number;
  @Output() paginationLoad = new EventEmitter<any>();
  @Output() iconEvent = new EventEmitter<any>();
  displayedColumns: string[] = [];
  data = new MatTableDataSource<any>;
  pageLength: any;
  // pageSize = 10;
  // pageIndex = 0;
  pageSizeOptions = [5, 10, 25];

  showDettaglio: boolean = false;
  showAssociaCompetenze: boolean = false;
  showAssociaConoscenze: boolean = false;
  showAssociaAbilita: boolean = false;
  showAssociaClassificazioni: boolean = false;

  showArchivioCompetenze: boolean = false;
  showArchivioProposte: boolean = false;

  modificaPropostaCompetenza: boolean = false;
  validaCompetenza: boolean = false;
  modificaProfiloProfessionale: boolean = false;
  validaProfilo: boolean = false;
  showElimina: boolean = false;
  showInvia: boolean = false;
  showAssociazioniProfiliAssemblea: boolean = false;
  showAssociazioniCompetenzeAssemblea: boolean = false;
  editAssociazioniProfiliAssemblea: boolean = false;
  editAssociazioniCompetenzeAssemblea: boolean = false;
  showDecreta: boolean = false;
  showEliminaAssemblea: boolean = false;
  showApprovaContenuti: boolean = false;
  showCaricaDocumenti: boolean = false;
  showDisabilitaUtente: boolean = false;

  showAbilitaOperatore: boolean = false;
  showDisabilitaOperatore: boolean = false;

  showAbilitaConoscenze: boolean = false;
  showModificaArea: boolean = false;
  showDettaglioArea: boolean = false


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private _httpClient: HttpClient) { }

  get detailIconToolTip(){
    return this.name === "gestioneOperatori" ? "Visualizza operatore" : "Visualizza dettaglio";
  }

  ngOnInit() {
    this.data = this.tableData;
    this.data.sort = this.sort;
    this.showIcons(this.name);
    this.displayedColumns = this.cols;
  }
  ngAfterViewInit() {
    this.data.paginator = this.paginator;
    this.pageLength = this.paginatorSize;
  }

  onSortData(sort: any) {
    if (sort.active && sort.direction !== '') {
      let sortedData = this.tableData.slice().sort((a: any, b: any) => {
        let firstValue = this.printElement(sort.active, a);
        let secondValue = this.printElement(sort.active, b);
        let comparison = 0;
        if (firstValue == null) firstValue = '';
        if (secondValue == null) secondValue = '';
        if(sort.active.includes('data')){
          const fieldSplitted = sort.active.split('_');
          const field = `${fieldSplitted[0]}${fieldSplitted[1].charAt(0).toUpperCase()}${fieldSplitted[1].slice(1)}`;
          firstValue = new Date(a[field]);
          secondValue = new Date(b[field]);
          comparison = firstValue > secondValue ? 1 : -1;
        } else if (sort.active.includes('codice_profilo')) {
          // ordinamento per codice profilo con priorità per codice area (decimale) e profilo progressivo (unità)
          let decimaleFirstValue = firstValue.split('.').length > 1 ? firstValue.split('.')[0] : firstValue;
          let unitaFirstValue = firstValue.split('.').length > 1 ? firstValue.split('.')[1] : -1;
          let decimaleSecondValue = secondValue.split('.').length > 1 ? secondValue.split('.')[0] : secondValue;
          let unitaSecondValue = secondValue.split('.').length > 1 ? secondValue.split('.')[1] : -1;

          decimaleFirstValue = firstValue === '' || Number.isNaN(Number(decimaleFirstValue)) ? -1 : Number(decimaleFirstValue);
          decimaleSecondValue = secondValue === '' || Number.isNaN(Number(decimaleSecondValue)) ? -1 : Number(decimaleSecondValue);
          unitaFirstValue = Number.isNaN(Number(unitaFirstValue)) ? -1 : Number(unitaFirstValue);
          unitaSecondValue = Number.isNaN(Number(unitaSecondValue)) ? -1 : Number(unitaSecondValue);

          if (decimaleFirstValue !== decimaleSecondValue) {
            comparison = decimaleFirstValue - decimaleSecondValue;
          } else {
            comparison = unitaFirstValue - unitaSecondValue;
          }
        } else{
          comparison = firstValue.toLowerCase() > secondValue.toLowerCase() ? 1 : -1;
        }
        return sort.direction === 'asc' ? comparison : -comparison;
      });
      this.data = sortedData;
    }
  }

  checkException(element: any) {
    return (!element.tipologia || element.tipologia.id == 1 || element.tipologia.id === 6);
  }
  showIcons(name: any) {

    // stato id 3 = decretato
    // stato id 1 = bozza
    // stato id 2 = completata
    switch (name) {
      case 'gestioneProfiloProfessionale': {
        this.showDettaglio = true;
        this.showAssociaCompetenze = true;
        this.showAssociaClassificazioni = true;
        this.showAssociaConoscenze = false;
        this.showAssociaAbilita = false;
        this.showElimina = true;
        this.showInvia = true;
        this.showDecreta = false;
        this.showDisabilitaUtente = false;
        this.modificaProfiloProfessionale = false;
        this.validaProfilo = false;
        this.modificaPropostaCompetenza = false;
        this.validaCompetenza = false;
        this.showAbilitaOperatore = false;
        this.showDisabilitaOperatore = false;
        this.showArchivioCompetenze = false;
        this.showArchivioProposte = false;
        this.showAssociazioniProfiliAssemblea = false;
        this.showAssociazioniCompetenzeAssemblea = false;
        this.showEliminaAssemblea = false;
        this.showApprovaContenuti = false;
        this.editAssociazioniProfiliAssemblea = false;
        this.editAssociazioniCompetenzeAssemblea = false;
        this.showAbilitaConoscenze = false;
        this.showCaricaDocumenti = false;
        break;
      }
      case 'gestioneCompetenze': {
        this.showDettaglio = true;
        this.showAssociaCompetenze = false;
        this.showAssociaClassificazioni = true;
        this.showAssociaConoscenze = true;
        this.showAssociaAbilita = true;
        this.showElimina = true;
        this.showInvia = true;
        this.showDecreta = false;
        this.showDisabilitaUtente = false;
        this.modificaProfiloProfessionale = false;
        this.validaProfilo = false;
        this.modificaPropostaCompetenza = false;
        this.validaCompetenza = false;
        this.showAbilitaOperatore = false;
        this.showDisabilitaOperatore = false;
        this.showArchivioCompetenze = false;
        this.showArchivioProposte = false;
        this.showAssociazioniProfiliAssemblea = false;
        this.showAssociazioniCompetenzeAssemblea = false;
        this.showEliminaAssemblea = false;
        this.showApprovaContenuti = false;
        this.editAssociazioniProfiliAssemblea = false;
        this.editAssociazioniCompetenzeAssemblea = false;
        this.showAbilitaConoscenze = false;
        this.showCaricaDocumenti = false;
        break;
      }
      case 'elencoProposteProfiloProfessionale': {
        this.showDettaglio = true;
        this.modificaProfiloProfessionale = true;
        this.validaProfilo = true;
        this.showDecreta = false;
        this.showDisabilitaUtente = false;
        this.showAbilitaOperatore = false;
        this.showDisabilitaOperatore = false;
        this.showArchivioCompetenze = false;
        this.showArchivioProposte = false;
        this.showAssociazioniProfiliAssemblea = false;
        this.showAssociazioniCompetenzeAssemblea = false;
        this.showEliminaAssemblea = false;
        this.showApprovaContenuti = false;
        this.editAssociazioniProfiliAssemblea = false;
        this.editAssociazioniCompetenzeAssemblea = false;
        this.showAbilitaConoscenze = false;
        this.showCaricaDocumenti = false;
        break;
      }
      case 'elencoProposteCompetenze': {
        this.showDettaglio = true;
        this.modificaPropostaCompetenza = true;
        this.validaCompetenza = true;
        this.showDecreta = false;
        this.showDisabilitaUtente = false;
        this.showAbilitaOperatore = false;
        this.showDisabilitaOperatore = false;
        this.showArchivioCompetenze = false;
        this.showArchivioProposte = false;
        this.showAssociazioniProfiliAssemblea = false;
        this.showAssociazioniCompetenzeAssemblea = false;
        this.showEliminaAssemblea = false;
        this.showApprovaContenuti = false;
        this.editAssociazioniProfiliAssemblea = false;
        this.editAssociazioniCompetenzeAssemblea = false;
        this.showAbilitaConoscenze = false;
        this.showCaricaDocumenti = false;
        break;
      }

      case 'archivioProposteProfiloProfessionale': {
        this.showDettaglio = true;
        this.modificaProfiloProfessionale = false;
        this.validaProfilo = false;
        this.modificaPropostaCompetenza = false;
        this.validaCompetenza = false;
        this.showDecreta = false;
        this.showDisabilitaUtente = false;
        this.showAbilitaOperatore = false;
        this.showDisabilitaOperatore = false;
        this.showArchivioCompetenze = false;
        this.showArchivioProposte = true;
        this.showAssociazioniProfiliAssemblea = false;
        this.showAssociazioniCompetenzeAssemblea = false;
        this.showEliminaAssemblea = false;
        this.showApprovaContenuti = false;
        this.editAssociazioniProfiliAssemblea = false;
        this.editAssociazioniCompetenzeAssemblea = false;
        this.showAbilitaConoscenze = false;
        this.showCaricaDocumenti = false;
        break;
      }

      case 'archivioProposteCompetenze': {
        this.showDettaglio = true;
        this.modificaProfiloProfessionale = false;
        this.validaProfilo = false;
        this.modificaPropostaCompetenza = false;
        this.validaCompetenza = false;
        this.showDecreta = false;
        this.showDisabilitaUtente = false;
        this.showAbilitaOperatore = false;
        this.showDisabilitaOperatore = false;
        this.showArchivioCompetenze = true;
        this.showArchivioProposte = false;
        this.showAssociazioniProfiliAssemblea = false;
        this.showAssociazioniCompetenzeAssemblea = false;
        this.showEliminaAssemblea = false;
        this.showApprovaContenuti = false;
        this.editAssociazioniProfiliAssemblea = false;
        this.editAssociazioniCompetenzeAssemblea = false;
        this.showAbilitaConoscenze = false;
        this.showCaricaDocumenti = false;
        break;
      }

      case 'gestioneAssemblea': {
        this.showDettaglio = true;
        this.modificaProfiloProfessionale = false;
        this.validaProfilo = false;
        this.modificaPropostaCompetenza = false;
        this.validaCompetenza = false;
        this.showDisabilitaUtente = false;
        this.showAbilitaOperatore = false;
        this.showDisabilitaOperatore = false;
        this.showArchivioCompetenze = false;
        this.showArchivioProposte = false;
        this.showAssociazioniProfiliAssemblea = true;
        this.showAssociazioniCompetenzeAssemblea = true;
        this.showDecreta = true;
        this.showEliminaAssemblea = true;
        this.showApprovaContenuti = true;
        this.editAssociazioniProfiliAssemblea = true;
        this.editAssociazioniCompetenzeAssemblea = true;
        this.showAbilitaConoscenze = false;
        this.showCaricaDocumenti = false;
        break;
      }

      case 'gestioneUtenze': {
        this.showDettaglio = true;
        this.modificaProfiloProfessionale = false;
        this.validaProfilo = false;
        this.modificaPropostaCompetenza = false;
        this.validaCompetenza = false;
        this.showDecreta = false;
        this.showDisabilitaUtente = true;
        this.showAbilitaOperatore = false;
        this.showDisabilitaOperatore = false;
        this.showArchivioCompetenze = false;
        this.showArchivioProposte = false;
        this.showAssociazioniProfiliAssemblea = false;
        this.showAssociazioniCompetenzeAssemblea = false;
        this.showEliminaAssemblea = false;
        this.showApprovaContenuti = false;
        this.editAssociazioniProfiliAssemblea = false;
        this.editAssociazioniCompetenzeAssemblea = false;
        this.showAbilitaConoscenze = false;
        this.showCaricaDocumenti = false;
        break;
      }

      case 'gestioneOperatori': {
        this.showDettaglio = true;
        this.modificaProfiloProfessionale = false;
        this.validaProfilo = false;
        this.modificaPropostaCompetenza = false;
        this.validaCompetenza = false;
        this.showDecreta = false;
        this.showDisabilitaUtente = false;
        this.showAbilitaOperatore = true;
        this.showDisabilitaOperatore = true;
        this.showArchivioCompetenze = false;
        this.showArchivioProposte = false;
        this.showAssociazioniProfiliAssemblea = false;
        this.showAssociazioniCompetenzeAssemblea = false;
        this.showEliminaAssemblea = false;
        this.showApprovaContenuti = false;
        this.editAssociazioniProfiliAssemblea = false;
        this.editAssociazioniCompetenzeAssemblea = false;
        this.showAbilitaConoscenze = false;
        this.showCaricaDocumenti = false;
        break;
      }

      case 'archivioAbilitaConoscenze': {
        this.showAbilitaConoscenze = true;
        break;
      }

      case 'caricaDocumenti': {
        this.showCaricaDocumenti = true;
        break;
      }

      case 'gestioneAree': {
        this.showModificaArea = true;
        this.showDettaglioArea = true;
        break;
      }

      default: break;
    }

  }
  printElement(col: any, el: any) {

    let element;
    switch (col) {
      case "azioni": {
        element = '';
        break;
      }

      case "area": {
        element = el.descrizioneArea ? el.descrizioneArea.descrizione : el.areaProfessionale.descrizione
        break;
      }

      case "codice_profilo": {
        element = el.codiceProfilo;
        break;
      }

      case "profilo": {
        element = el.nomeProfilo
        break;
      }

      case "data_riunione": {
        let dateFormat = new Date(el.dataRiunione)
        element = dateFormat.getDate() + '/' + ((dateFormat.getMonth() + 1) < 10 ? ('0' + (dateFormat.getMonth() + 1)) : (dateFormat.getMonth() + 1)) + '/' + dateFormat.getFullYear();
        break;
      }

      case "data_approvazione": {
        let dateFormat = new Date(el.dataApprovazione)
        element = dateFormat.getDate() + '/' + ((dateFormat.getMonth() + 1) < 10 ? ('0' + (dateFormat.getMonth() + 1)) : (dateFormat.getMonth() + 1)) + '/' + dateFormat.getFullYear();
        break;
      }

      case "stato": {
        element = el.stato.descrizione
        break;
      }

      case "stato_proposta": {
        element = el.statoProposta ? el.statoProposta.descrizione : el.stato.descrizione
        break;
      }

      case "stato_profilo": {
        element = el.statoProposta.descrizione
        break;
      }


      case "tipologia": {
        element = el.tipologia.descrizione
        break;
      }

      case "descrizione": {
        element = el.descrizione
        break;
      }

      case "competenza": {
        element = el.descrizione
        break;
      }

      case "stato_competenza": {
        element = el.stato.descrizione
        break;
      }

      case "posizione": {
        element = el.posizione
        break;
      }

      case "cf": {
        element = el.codiceFiscale
        break;
      }

      case "nome": {
        element = el.nomeUtente
        break;
      }

      case "cognome": {
        element = el.cognomeUtente
        break;
      }

      case "attivo": {
        element = el.flagAttivo
        break;
      }

      case "nome_operatore": {
        element = el.descrizione
        break;
      }

      case "area_sep": {
        element = el.idAreaSep
        break;
      }

      case "id_area": {
        element = el.id;
        break;
      }

      case "stato_area": {
        element = el.statoArea.descrizione;
        break;
      }

    }

    return element;
  }

  printCol(col: any) {
    let col_name;
    switch (col) {
      case "area": {
        col_name = "Area Professionale"
        break;
      }
      case "profilo": {
        col_name = "Profilo Professionale"
        break;
      }
      case "codice_profilo": {
        col_name = "Codice Profilo"
        break;
      }
      case "stato": {
        col_name = "Stato"
        break;
      }
      case "stato_proposta": {
        col_name = "Stato Proposta"
        break;
      }
      case "stato_profilo": {
        col_name = "Stato Profilo"
        break;
      }
      case "stato_competenza": {
        col_name = "Stato Competenza"
        break;
      }
      case "posizione": {
        col_name = "Posizione"
        break;
      }
      case "tipologia": {
        col_name = "Tipologia"
        break;
      }
      case "descrizione": {
        col_name = "Descrizione"
        break;
      }
      case "competenza": {
        col_name = "Competenza"
        break;
      }
      case "attivo": {
        col_name = "Attivo"
        break;
      }
      case "data_riunione": {
        col_name = "Data Riunione"
        break;
      }
      case "data_approvazione": {
        col_name = "Data Approvazione"
        break;
      }
      case "nome": {
        col_name = "Nome"
        break;
      }
      case "cognome": {
        col_name = "Cognome"
        break;
      }
      case "cf": {
        col_name = "Codice Fiscale"
        break;
      }
      case "nome_operatore": {
        col_name = "Nome Operatore"
        break;
      }
      case "azioni": {
        col_name = "Azioni"
        break;
      }
      case "id_area": {
        col_name = "ID"
        break;
      }
      case "area_sep": {
        col_name = "Area SEP"
        break;
      }
      case "stato_area": {
        col_name = "Stato"
        break;
      }
      default: {
        col_name = ""
        break;
      }
    }

    return col_name;
  }


  handleIconClick(el: any, type: string) {
    let data = {
      element: el,
      type
    }
    this.iconEvent.emit(data);
  }


  onPaginateChange(event: any) {

    let data = {
      index: event.pageIndex,
      pageSize: event.pageSize
    }
    this.paginationLoad.emit(data)
  }
}






